import React from 'react';
import "./index.css";

function Review(){
    return (
        //여기에는 나랑 몇 명 애들 해서 실제 소감 같은 것을 적을 예정
            <div>
    <div className="testscore"><img className="ddabong" src="https://cdn-icons-png.flaticon.com/512/651/651191.png" alt="따봉이미지"/>Review</div>
            
            <div className="review">
            
            <div className="woojin">
                <div className="name"><br/>학생1</div>
                
                <div className="text1">
                <br/><br/>
                선생님께 파닉스부터 차근차근 배우면서 영어를 처음 접해보았을 때가 생각나는데요! <br/><br/>
                공부에 대해서는 전혀 관심없던 초등학생 때부터 영어의 중요성에 대해 가르쳐주셨습니다. <br/><br/>
                그래서 고등학교 진학시에도 자신있게 '외고'에 지원해보게 되었고, 또 대학에 온 지금도 영어라면 두려움이 없게 되었습니다. <br/><br/>
                선생님과 초등학교 때부터 했던 단어시험, 독해노트, 그리고 영어 일기 써보고 첨삭 받는 활동 등은 서울 친구들 못지 않은 발판을 마련해주었고, 이는 고등학교 , 대학교 공부에서도 잔잔하지만 확실한 실력으로 내보였던 것 같습니다.<br/><br/>
                특히나 난이도 맞는 친구들과 함께 하는 그룹 수업은 그 무엇보다도 시너지 효과가 컸고, 많은 자극이 되었습니다. <br/><br/>
                선생님께서 직접 만드신 문법 노트는 제가 사립 중학교 시험을 볼 때 입학시험 영어 2등을 달성할 만큼 도움이 많이 되었는데요, <br/>
                아무래도 입시 시험이나 이후 수능 독해, 토익 등에 문법은 빠지지 않고 나와서 중요한 부분입니다. 
                선생님 감사합니다!
                </div>
            </div>
            <div className="youngseo">
            <div className="name"><br/>학생2</div>
                <div className="text1">
                <br/><br/>
                선생님께 유치원부터 중학생때까지 배우면서 파닉스부터 다양한 자격증과 고등영어를 배웠습니다. <br/><br/>
                선생님께 배운 것들은 아무래도 어렸을 때부터 다져왔던 것이라 이후 영어실력의 80프로 이상을 차지할 만큼 도움이 많이 됐습니다. <br/><br/>
                저는 사실 어렸을때 공부하는 것을 싫어하던 학생이었는데요 ㅎㅎ 그럴때마다 선생님이 잘 이끌어주셔서 영어 실력 향상에 많은 도움을 주셨습니다. <br/><br/>
                영어뿐 아니라 공부하는 습관을 알려주시고 같이 공부하는 친구들과 영어를 실제로 
                사용해보며 영어에 대한 친숙도 또한 높였습니다. <br/><br/>
                서울이 아닌 지역에서, 매일매일 있는 단어 시험과 독해노트 숙제 그리고 일주일에 한번씩 듣기 수업을 하는 체계적인 수업을 받은 덕에<br/>
                이후 서울에 있는 외고에 온 이후에도 또래 친구들 못지 않은 정말 좋은 영어 실력을 갖게 됐습니다. <br/><br/>
                특히, 독해노트는 당시에는 어린 마음에 매우 귀찮아 했던 것 같은데요ㅎㅎ 이후에 긴 영어 지문을 해석할때 정말 많은 도움이 됐습니다. <br/><br/>
                중학교 이후에 영어 공부를 거의 하지 않았지만 어렸을때부터 해 온 선생님과의 영어 수업 덕에 다른 공부에도 더욱 집중할 수 있게 되어 대학에 올 수 있었습니다 <br/>감사합니다!
                </div>
            </div>
        </div>
        </div>
    )
};

export default Review;
